import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { token } = await adminLogin(username, password);
      localStorage.setItem("ve_admin_token", token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center bg-slate-50 px-4 py-16">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white rounded-3xl border border-slate-200 p-8 lg:p-10 shadow-sm"
        data-testid="admin-login-form"
      >
        <span className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center mb-5">
          <Lock className="w-5 h-5 text-amber-600" />
        </span>
        <h1 className="font-heading text-3xl font-semibold text-slate-900">
          Admin sign-in
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Restricted area — Veer Electrical staff only.
        </p>

        <div className="mt-7 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-slate-500 font-bold mb-2">
              Username
            </label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-amber-500 outline-none"
              data-testid="admin-username"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-slate-500 font-bold mb-2">
              Password
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              required
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-amber-500 outline-none"
              data-testid="admin-password"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={busy}
          className="mt-7 w-full px-6 py-3 bg-slate-900 text-white rounded-full font-medium hover:bg-amber-500 hover:text-slate-900 transition-colors disabled:opacity-50"
          data-testid="admin-login-submit"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
